module.exports = __webpack_public_path__ + "img/none.525ac5e8.png";